<template>
    <Link :url="'/search/centre/' + space.slug + returnUrl()" :linkType="linkType" :className="'rent--spaces-item'">
            <div class="rent--spaces-item-logo">
                <img :src="space.featuredLogoUrl">
            </div>
            <div href="#" @click.prevent="saved ? removeSpace(space.id) : saveSpace(space.id)" class="rent--spaces-item-save" :class="{ 'is--saved': saved }">
                <svg width="34" height="31" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="heart-fill" d="M33 10.3796C33 12.8539 32.0499 15.2306 30.3533 16.9886C26.4478 21.0368 22.6598 25.2581 18.6085 29.1595C17.6798 30.0408 16.2067 30.0086 15.3181 29.0875L3.64601 16.9886C0.117996 13.3315 0.117996 7.42757 3.64601 3.77051C7.2087 0.0775195 13.0127 0.0775195 16.5754 3.77051L16.9997 4.21027L17.4237 3.77077C19.1318 1.9992 21.4582 1 23.8885 1C26.3187 1 28.645 1.9991 30.3533 3.77051C32.0501 5.52872 33 7.90523 33 10.3796Z" fill="white" fill-opacity="0.5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8885 1.5C21.5964 1.5 19.3992 2.44226 17.7836 4.11782L17.3595 4.55742C17.2653 4.65509 17.1354 4.71027 16.9997 4.71027C16.864 4.71028 16.7341 4.65512 16.6399 4.55745L16.2155 4.11769C12.8495 0.628505 7.37193 0.628469 4.00586 4.11766C0.664716 7.58101 0.664712 13.1781 4.00586 16.6415L15.6779 28.7404C16.3755 29.4634 17.5335 29.4892 18.2632 28.7979C20.9608 26.2 23.5345 23.467 26.1139 20.728C27.4003 19.362 28.6881 17.9945 29.9934 16.6415C31.5986 14.9782 32.5 12.7266 32.5 10.3796C32.5 8.03255 31.5988 5.78114 29.9935 4.11773C28.3777 2.44229 26.1806 1.5 23.8885 1.5ZM17.0638 3.42362C18.8646 1.5561 21.3201 0.5 23.8885 0.5C26.4569 0.5 28.9123 1.55604 30.7132 3.42343C32.5014 5.27641 33.5 7.77798 33.5 10.3796C33.5 12.9812 32.5012 15.4829 30.7131 17.3358M17.0638 3.42362C17.0639 3.42359 17.0638 3.42365 17.0638 3.42362ZM17.0638 3.42362L16.9996 3.49015L16.9352 3.42337C16.9352 3.42338 16.9352 3.42335 16.9352 3.42337C13.1759 -0.473399 7.04546 -0.473419 3.28617 3.42336C-0.428724 7.27413 -0.42872 13.485 3.28616 17.3358L14.9582 29.4347C16.0376 30.5535 17.825 30.5923 18.9527 29.5222L18.9553 29.5197C21.6705 26.905 24.2746 24.1398 26.865 21.3893C28.1471 20.0279 29.426 18.67 30.7131 17.3358" fill="#FFFFFF"/>
                </svg>
            </div>
            <div class="rent--spaces-item-image">
                <img v-lazy="space.featuredImageUrl">
            </div>
            <div class="rent--spaces-item-box">
                <div class="rent--spaces-item-title">
                    {{ space.title }}
                </div>
                <div class="rent--spaces-item-small">{{ space.city ? space.city : space.address }}</div>
                <div class="rent--spaces-item-tags">
                    <div v-if="space.name == 'Pop-up,Event,Promotion,Advertising,Kiosk / Stand'">
                        <div class="rent--spaces-item-tag">{{$store.getters.language.All_Space_Types}}</div>
                    </div>
                    <div v-else v-for="category in space.name.replace(' / Stand', '').split(',')">
                        <div class="rent--spaces-item-tag">{{category}}</div>
                    </div>
                </div>
        </div>
    </Link>
</template>

<script>
import axios from 'axios'
import Link from "../../components/global/Link"

    export default {
        name: 'CentreCard',
        data: () => ({
            saved: false
        }),
        props: {
            space: {
                type: Object,
                default: null
            },
            linkType: {
                type: String,
                default: null
            },
            user: {
                type: Object,
                default: null
            }
        },
        watch: {
            // Watch for state changes
            user: {
              handler (state) {
                this.getSaved()
              },
              deep: true
            }
        },
        components: {
            Link
        },
        computed: {
        },
        mounted() {
        },
        created() {
            this.getSaved()
        },
        methods: {
            getSaved () {
                if (this.user && this.user.saved_items.filter(e => e.save_type === 'listing_group' && e.listing_group.id === parseInt(this.space.id)).length > 0) {
                  this.saved = true
                }
            },
            saveSpace (id) {
              var self = this
              var token = document.head.querySelector("[name=csrf-token]").content;
              const res = axios.get('/api/listings/save_centre?listing_group_id=' + id,
              { headers: {
                'Content-type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
              }
              }).then(response => {
                if (response.data.message === 'no_user_session') {
                    this.$store.commit('savedModal', true)
                } else {
                    self.saved = true
                }
              }).catch(err => {
                console.log("Error: "+ err)
              })
            },
            removeSpace (id) {
              var self = this
              var token = document.head.querySelector("[name=csrf-token]").content;
              const res = axios.get('/api/listings/remove_saved_space?listing_group_id=' + id,
              { headers: {
                'Content-type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
              }
              }).then(response => {
                self.saved = false
                self.$emit('updateSpace', true)
              }).catch(err => {
                console.log("Error: "+ err)
              })
            },
            returnUrl() {
                return window.location.search ? window.location.search : ''
            },
            addToCart(id) {
                // Add post request here
                console.log('Add ' + id)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import "../../scss/global/includes";

    .rent--spaces-item {
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }

    .rent--spaces-item-height {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .rent--spaces-item-wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 0;
    }

    .rent--spaces-item-image {
        height: 100%;
        width: 100%;
        aspect-ratio: 1/1;
        display: block;
        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            display: block;
        }
        &:after {
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            width: 100%;
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1000;
            opacity: 1;
            transition: all 0.3s ease-in-out;
        }
        &:hover {
            &:after {
                opacity: 0.8;
            }
        }
    }

    .rent--spaces-item-box {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 1001;
        display: grid;
        grid-gap: 4px;
        grid-template-columns: 1fr;
        padding: 16px;
        color: #FFFFFF;
    }

    .rent--spaces-item-small {
        @include responsive-text-size('Title--18--Regular');
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: #FFFFFF;
        @include ease-fast;
    }

    .rent--spaces-item-title {
        @include responsive-text-size('Title--22--Bold');
        width: 100%;
        color: #FFFFFF;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        @include ease-fast;
    }

    .rent--spaces-item-tags {
        margin-top: 4px;
        display: flex;
        flex-wrap: wrap;
        gap: 4px 4px;
    }

    .rent--spaces-item-tag {
        @include responsive-text-size('Title--18--Regular');
        padding: 2px 4px;
        background: transparent;
        border-radius: 4px;
        color: #FFFFFF;
        border: 1px solid #FFFFFF;
        @include ease-fast;
    }

    .rent--spaces-item-price {
        font-family: $font-bold;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: right;
    }

    .rent--spaces-item-logo {
        position: absolute;
        top: 0;
        left: 8px;
        height: 50px;
        width: 50px;
        background: $white;
        z-index: 1001;
        border-radius: 0 0 4px 4px;
        overflow: hidden;
    }

    .rent--spaces-item-save {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 32px;
        z-index: 1001;
        cursor: pointer;

        svg path {
            @include ease-fast;
        }

        &.is--saved {
            .heart-fill {
                fill: $primary;
                fill-opacity: 1;
            }
        }
    }

    .rent--spaces-item-quick-view, .rent--spaces-item-floorplan {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1001;
        font-size: 10px;
        letter-spacing: -0.2px;
        background: #65DCBD;
        color: #FFFFFF;
        box-shadow: 0px 0px 2px 0px #8A8A8A;
        border-radius: 3px;
        padding: 5px 5px 5px 5px;
        display: flex;
        gap: 5px;
        align-items: center;
        svg {
            width: 10px;
        }
        &:focus {
            color: #FFFFFF;
        }
        &:hover {
            color: #FFFFFF;
        }
    }

    .rent--spaces-add-cart {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1001;
        background: $primary;
        border-radius: 26px;
        padding: 5px 10px 5px 10px;
        font-size: 11px;
        color: #ffffff;
        font-family: $font-bold;
        @include ease-fast;
        &:hover {
            color: #FFFFFF;
            background: $strong-brand;
        }
    }

</style>
